import { useEffect } from 'react';
import { clsx } from 'clsx';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { WizardStepBaseProps } from '../../../../wizard/interfaces/wizard-step-base-props';
import { SourceType } from '../../../../shared/interfaces/source';
import { SelectSourceType } from '../../../../sources/SelectSourceType/SelectSourceType';
import styles from './CreatePipelineSelectSourceType.module.scss';
import { useCreatePipelineContext } from '../../hooks/useCreatePipelineContext';
import { useAnalyticsTracker } from '../../../../tracking/hooks/useAnalyticsTracker';
import { CreatePipelineTrackers } from '../../../tracking/create-pipeline-trackers';

export function CreatePipelineSelectSourceType({
  completeStep,
  updateWizardStepFooterProps
}: WizardStepBaseProps) {
  const { updateState, pipeline, standardPipelineInfo, isUpgradingPipeline } =
    useCreatePipelineContext();
  const { eventTrack } = useAnalyticsTracker();
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const commonSourceType = searchParams.get('source_type');
  const isCommonSourceTypeFlow = commonSourceType ? commonSourceType.length > 0 : false;

  useEffect(() => {
    updateWizardStepFooterProps({
      entity: 'Source'
    });

    return () => {
      updateWizardStepFooterProps({});
    };
  }, []);

  const onSourceTypeSelect = (sourceType: SourceType) => {
    eventTrack({
      action: CreatePipelineTrackers.PIPELINE_TRACKER_CREATE_PIPELINE_SELECT_SOURCE_TYPE,
      properties: {
        sourceType: sourceType.sourceType,
        pipelineId: pipeline!.id
      }
    });

    updateState({
      source: null,
      sourceType
    });

    completeStep();
  };

  if (isCommonSourceTypeFlow) {
    navigate('/pipeline/create/select-source');
    return null;
  }

  return (
    <div className='scrollable-content'>
      <div className={clsx('m-auto center-flex-col', styles.selectSourceTypeContainer)}>
        <SelectSourceType
          isUpgradingPipeline={isUpgradingPipeline}
          standardPipelineInfo={standardPipelineInfo}
          onSourceTypeSelect={onSourceTypeSelect}
        />
      </div>
    </div>
  );
}
